/**
 * Developed By Aritra Basak, EY
 */

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

export const UseStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    padding: 12,
    overflow: "scroll",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    minWidth: 170,
  },
  button: {
    margin: theme.spacing(1),
  },
}));

export default function DemoAuthRegisterAbha() {
  const classes = UseStyles();
  return (
    <React.Fragment>
      <Grid className="grid-container">
        <Grid item style={{ marginTop: 15 }}>
          <h5>
            <strong>Do you have an ABHA Id?</strong>
          </h5>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/demoAuthVerifyAbha"
            className={classes.button}
          >
            YES
          </Button>
          <Button
            variant="contained"
            color="default"
            component={Link}
            to="/demoAuthGenerateAbha"
            className={classes.button}
          >
            NO
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
